import Headroom from 'headroom.js';
import { CountUp } from 'countup.js';
import Swiper from 'swiper';
import Lenis from 'lenis'

jQuery(document).ready(function ($) {


	const DEV = 0



	var myHeader = document.querySelector("header");
	var headroom = new Headroom(myHeader, {
		offset: {
	        up: 150,
	        down: 130
	    },
		tolerance : {
	        up : 20,
	        down : 0
	    },
	});
	headroom.init();





	// COUNT UPS
	// https://github.com/inorganik/CountUp.js
	$('.front_page .numbers_container li').each(function(){
		let number = $(this).data('number')
		let decimal = $(this).data('decimal')
		DEV && log('number', number)

		let id = $(this).find('span').attr('id')
		DEV && log('id', id)
		let options = {
			decimalPlaces: decimal,
			enableScrollSpy: true,
			separator: ',',
			// scrollSpyDelay: 200
		}
		const countUp = new CountUp(id, number, options);
		countUp.start();
	})









	// Initialize Lenis with autoRaf disabled
	const lenis = new Lenis({
	    autoRaf: true,
	    allowNestedScroll: true
	});

		// Function to manually trigger Lenis and sync scroll updates
		function raf(time) {
		    lenis.raf(time);           // Handle smooth scrolling
		    requestAnimationFrame(raf);  // Keep the animation loop running
		}

		// Start the Lenis scroll loop
		requestAnimationFrame(raf);










	let mobile_swiper_image_options = {
		speed: 900,
    	direction: 'horizontal',
    	loop: true,  // default: false
    	autoHeight: true,
    	effect: 'slide',
		breakpoints: {
		    320: {
		      slidesPerView: 1.2,
		      spaceBetween: 20
		    },
		    480: {
		      slidesPerView: 3,
		      spaceBetween: 20
		    }
		}
	}

	if (document.querySelector('.page.our_industry .banner.everyday .swiper')) {
		var everyday_swiper = new Swiper ('.page.our_industry .banner.everyday .swiper',
			mobile_swiper_image_options
		)
	}

	if (document.querySelector('.page.our_industry .banner.essential .swiper')) {
		var everyday_swiper = new Swiper ('.page.our_industry .banner.essential .swiper',
			mobile_swiper_image_options
		)
	}














}); // end ready
